/* tslint:disable */
/* eslint-disable */
/**
 * AdServer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { mapValues } from '../runtime';
import { AggregatedStatFromJSON, AggregatedStatFromJSONTyped, AggregatedStatToJSON, AggregatedStatToJSONTyped, } from './AggregatedStat';
/**
 * Check if a given object implements the StatsSlotSlotIdAggregateddurationGet200Response interface.
 */
export function instanceOfStatsSlotSlotIdAggregateddurationGet200Response(value) {
    return true;
}
export function StatsSlotSlotIdAggregateddurationGet200ResponseFromJSON(json) {
    return StatsSlotSlotIdAggregateddurationGet200ResponseFromJSONTyped(json, false);
}
export function StatsSlotSlotIdAggregateddurationGet200ResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'booked': json['booked'] == null ? undefined : (mapValues(json['booked'], AggregatedStatFromJSON)),
        'unbooked': json['unbooked'] == null ? undefined : (mapValues(json['unbooked'], AggregatedStatFromJSON)),
    };
}
export function StatsSlotSlotIdAggregateddurationGet200ResponseToJSON(json) {
    return StatsSlotSlotIdAggregateddurationGet200ResponseToJSONTyped(json, false);
}
export function StatsSlotSlotIdAggregateddurationGet200ResponseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'booked': value['booked'] == null ? undefined : (mapValues(value['booked'], AggregatedStatToJSON)),
        'unbooked': value['unbooked'] == null ? undefined : (mapValues(value['unbooked'], AggregatedStatToJSON)),
    };
}
